export default __webpack_public_path__ + "static/media/SwatGif3T[1].dd3fb4fc.gif";